import axios from './index';

export const _getStaff = () => {
  return axios.get(`public/v1/app/get-staff`);
};

export const _createStaff = (reqObj) => {
  return axios.post(`public/v1/app/staff-create`, reqObj);
};

export const _updateStaffPassword = (reqObj) => {
  return axios.put(`public/v1/app/update-password`, reqObj);
};

export const _getAllUsers = () => {
  return axios.get(`public/v1/app/get-customer`);
};

// v2
export const getSelfRequest = () => axios.get('v1/admins/get/admin');

export const getAdminsRequest = () => axios.get('v1/admins/get/admins/-/-/-');

export const updateSelfRequest = (payload) =>
  axios.put('v1/admins/update/admin', payload);

export const updateSelfPwdRequest = (payload) =>
  axios.put('v1/admins/update/admin/password', payload);

export const createAdminRequest = (payload) =>
  axios.post('v1/admins/create/admin', payload);

export const updateAdminRequest = (id, payload) =>
  axios.put(`v1/admins/update/admin/${id}`, payload);

export const resetAdminPwdRequest = (id) =>
  axios.put(`v1/admins/reset/admin/password/${id}`);

export const toggleAdminStatusRequest = (id, payload) =>
  axios.put(`v1/admins/toggle/admin/${id}/access-status`, payload);

// ISSUER / Client Portal v2 ENDPOINTS
export const getIssuerProfileRequest = () =>
  axios.get('v1/issuer-staffs/get/issuer-staff');

export const updateIssuerSelfRequest = (payload) =>
  axios.put('v1/issuer-staffs/update/issuer-staff', payload);

export const updateIssuerSelfPwdRequest = (payload) =>
  axios.put('v1/issuer-staffs/update/issuer-staff/password', payload);

export const createIssuerRequest = (payload) =>
  axios.post('v1/issuer-staffs/create/issuer-staff', payload);

export const getIssuerStaffsRequest = () =>
  axios.get('v1/issuer-staffs/get/issuer-staffs/-/-/-');

export const updateIssuerStaffRequest = (id, payload) =>
  axios.put(`v1/issuer-staffs/update/issuer-staff/${id}`, payload);

export const resetIssuerStaffPwdRequest = (id) =>
  axios.put(`v1/issuer-staffs/reset/issuer-staff/password/${id}`);

export const toggleIssuerStatusRequest = (id) =>
  axios.put(`v1/issuer-staffs/toggle/issuer-staff/${id}/access-status`);
